import { request } from "../utils/request";
import { BACKEND_BASE_URL } from "./Resolver";

export type RegionConfiguration = {
  primary_regions: string[];
  secondary_regions: string[];
};

export class Regions {
  public static async getRegions(): Promise<RegionConfiguration> {
    const url = new URL(`${BACKEND_BASE_URL}/api/v1/regions`);
    const response = await request(url, { method: "GET" }, true);
    return await response.json();
  }
}
